import { createAsyncThunk } from "@reduxjs/toolkit";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { listingStata } from "./index";
import { getLatLng } from "../../utils/helperFunctions/getLocation";
import { uploadToCloudinary } from "../../utils/helperFunctions/uploadToCloudinary";
import { fetchListingSlice } from "./fetchListingsforUser";
import { fetchStateListingApi } from "./fetchStateListingThunk";
// import { fetchListingSlice } from "./fetchAllListings";
interface ICreateResponse {
  message: string;
}
interface IRejectValue {
  message: string;
}

export const createListingThunk = createAsyncThunk<
  ICreateResponse,
  listingStata,
  { rejectValue: IRejectValue }
>("listing/createListing", async (userListing, thunkAPI) => {
  if (!userListing.uid) {
    return thunkAPI.rejectWithValue({ message: "Invalid UID" });
  }

  try {
    const uploadedUrls: string[] = await Promise.all(
      userListing.images
        .slice(0, 6)
        .map((file: File) => uploadToCloudinary(file))
    );
    const location = await getLatLng(userListing.address);
    const listingId = crypto.randomUUID();

    const userDocRef = doc(db, "allListings", listingId);

    // for each list for listingId unique id

    const newListing = {
      ...userListing,
      location: location,
      images: uploadedUrls,
      id: listingId,
      createdAt: Date.now()
    };

    await setDoc(userDocRef, newListing);

  

    thunkAPI.dispatch(fetchListingSlice.util.invalidateTags(["allListings"]));
    thunkAPI.dispatch(
      fetchStateListingApi.util.invalidateTags([{ type: "LISTINGS" }])
    );

    return { message: "Listing created successfully." };
  } catch (error) {
    console.error(error);
    return thunkAPI.rejectWithValue({ message: "Error creating listing" });
  }
});
